import { render, staticRenderFns } from "./HouseInsert.vue?vue&type=template&id=5b187c05"
import script from "./HouseInsert.vue?vue&type=script&lang=js"
export * from "./HouseInsert.vue?vue&type=script&lang=js"
import style0 from "./HouseInsert.vue?vue&type=style&index=0&id=5b187c05&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports